<button type="button" class="star-line-item" (click)="clicked.emit()">
  <svg-icon
    src="assets/icons/icon-super-stars.svg"
    [svgStyle]="{ 'width.rem': 1.125, 'height.rem': 1.125 }"
    class="star-icon"
  ></svg-icon>
  <span class="star-name">{{ name }}</span>
  <svg-icon
    src="assets/icons/icon-zoom-in.svg"
    [svgStyle]="{ 'width.rem': 1.25, 'height.rem': 1.25 }"
    class="action-icon"
  ></svg-icon>
</button>
